import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GlobalLoaderComponent } from './components/global-loader/global-loader.component';
import { VexModule } from '../@vex/vex.module';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { CommonModule } from '@angular/common';
import { helpersModule } from './helpers/helpersModule.module'
import { itemService } from './helpers/services/main.service'
import { rfqEquation } from './pages/rfq/helpers/equation'
import { prodEquation } from './pages/prod_tracking/helpers/equation'
import { licensingEquation } from './pages/licensing_tracking/helpers/equation'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthGuardService } from './pages/auth/helpers/auth.guard';
import { RoleGuardService } from './pages/auth/helpers/role-guard.service';
import { AuthService } from './pages/auth/helpers/auth.service';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { HttpErrorInterceptor } from './helpers/http-error.interceptor';
import { GlobalErrorHandler } from './helpers/global-error-handler';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { NotificationsService } from 'angular2-notifications';
import { UserAuthInterceptor } from './helpers/interceptor/user-auth.interceptor';
import { LoaderInterceptor } from './helpers/interceptor/loader.interceptor';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { ItemDetailService } from './helpers/services/item_detail.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import moment from 'moment';
import { QuillModule } from 'ngx-quill'
import { quillConfigFactory } from './pages/comments/quillConfigFactory';
import { ConfigService } from './helpers/services/config.service';
import { AzureSsoService } from './helpers/services/azure-sso.service';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// AG Grid module registration lives in ONE place — `helpers/ag-grid/ag-grid-modules.ts`.
// It is NOT imported here: each lazy grid feature module imports it for its side
// effect so AG Grid Enterprise is absent from the login / first bundle.

// PrimeNG Imports
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';

// ✅ Function for APP_INITIALIZER
export function initConfig(configService: ConfigService) {
  return () => configService.loadConfig();
}

/**
 * Initialise MSAL on every page load — including inside the popup window that
 * Microsoft redirects back to after authentication.  Without this, the popup
 * never intercepts the auth-code response and just renders the full login page.
 */
export function initMsal(azureSso: AzureSsoService) {
  return () => azureSso.initialize();
}


export function momentAdapterFactory() {
    return adapterFactory(moment);
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [SimpleNotificationsModule.forRoot({
            position: ["bottom", "right"],
            timeOut: 5000,
            lastOnBottom: true,
            clickToClose: true,
        }),
        GlobalLoaderComponent,
        MatDatepickerModule,
        MatSnackBarModule,
        CommonModule,
        helpersModule,
        BrowserModule,
        AppRoutingModule,
        FontAwesomeModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: momentAdapterFactory,
        }),
        // Vex
        VexModule,
        CustomLayoutModule,
        MatFormFieldModule,
        MatSelectModule,
        MatNativeDateModule,
        MatMomentDateModule,
        MatTooltipModule,
        MatOptionModule,
        QuillModule.forRoot(quillConfigFactory()),
        // PrimeNG Modules
        CarouselModule,
        ButtonModule], providers: [itemService, ItemDetailService, prodEquation, licensingEquation, rfqEquation, AuthGuardService, RoleGuardService, AuthService, NotificationsService, {
            useClass: HttpErrorInterceptor,
            multi: true,
            provide: HTTP_INTERCEPTORS,
        },
        {
            useClass: UserAuthInterceptor,
            multi: true,
            provide: HTTP_INTERCEPTORS,
        },
        {
            useClass: LoaderInterceptor,
            multi: true,
            provide: HTTP_INTERCEPTORS,
        },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
        JwtHelperService,
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [ConfigService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initMsal,
            deps: [AzureSsoService],
            multi: true
        },
        { provide: MAT_CHIPS_DEFAULT_OPTIONS, useValue: {} }, 
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG({ /* options */ })
    ]})
export class AppModule { }
